<template>
  <v-slide-x-reverse-transition>
    <v-card class="elevation-5 action-details vop-bg-whisper" v-show="isVisible">
      <div>
        <!-- Header title -->
        <v-toolbar flat color="vop-bg-whisper">
          <v-toolbar-title class="subheading ttu font-weight-medium">
            <span v-if="isEditMode">{{ messages.label.EDIT_ACTION }}</span>
            <span v-else>{{ messages.label.ADD_ACTION }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="hide()">
            <v-icon medium>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex>
              <v-form>
                <!-- Action Type -->
                <v-flex xs8>
                  <v-select v-model="action.actionType" label="Action Type" v-validate="'required'"
                    :error-messages="errors.collect('actionType')" data-vv-name="actionType" :items="actionTypes"
                    item-text="title" item-value="value" required>
                  </v-select>
                </v-flex>
                <!-- Title -->
                <v-flex xs8>
                  <v-text-field v-model="action.title" v-validate="'required|max:100'"
                    :error-messages="errors.collect('title')" data-vv-name="title" data-vv-delay="500" :counter="100"
                    label="Title" required>
                  </v-text-field>
                </v-flex>
                <!-- Field -->
                <v-flex xs8>
                  <v-autocomplete v-model="action.field" label="Field" v-validate="'required'"
                    :error-messages="errors.collect('actionField')" data-vv-name="actionField" :items="xpathMappings"
                    item-text="title" item-value="xpathLocation" :loading="loadingXpathMappings" required>
                  </v-autocomplete>
                </v-flex>
                <v-flex>
                  <!-- Insert Attriubte -->
                  <template v-if="action.actionType === 'insertAttribute'">
                    <v-layout class="indigo lighten-5" column>
                      <v-layout row class="pt-2">
                        <v-flex xs6 offset-xs1>
                          <v-text-field v-model="action.attributeName" v-validate="'required|max:100'"
                            :error-messages="errors.collect('attributeName')" data-vv-name="maxLengthValue"
                            label="Attribute Name" required>
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs6 offset-xs1>
                          <v-text-field v-model="action.attributeValue" v-validate="'required|max:100'"
                            :error-messages="errors.collect('attributeValue')" data-vv-name="maxLengthValue"
                            label="Attribute Value" required>
                          </v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </template>
                  <!-- Delete Attribute -->
                  <template v-if="action.actionType === 'deleteAttribute'">
                    <v-layout class="indigo lighten-5" row wrap>
                      <v-flex xs6 offset-xs1>
                        <v-text-field v-model="action.attributeName" v-validate="'required|max:100'"
                          :error-messages="errors.collect('attributeName')" data-vv-name="maxLengthValue"
                          label="Attribute Name" required>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </template>
                  <!-- Insert Element -->
                  <template v-if="action.actionType === 'insertElement'">
                    <v-layout class="indigo lighten-5" row wrap>
                      <v-flex xs6 offset-xs1>
                        <v-text-field v-model="action.elementName" v-validate="'required|max:100'"
                          :error-messages="errors.collect('elementName')" data-vv-name="maxLengthValue"
                          label="Element Name" required>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </template>
                  <!-- Updte Element -->
                  <template v-if="action.actionType === 'updateElement'">
                    <v-layout class="indigo lighten-5" row wrap>
                      <v-flex xs6 offset-xs1>
                        <v-text-field v-model="action.elementName" v-validate="'required|max:100'"
                          :error-messages="errors.collect('elementName')" data-vv-name="maxLengthValue"
                          label="Updated with Name" required>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </template>
                  <!-- Delete Element -->
                  <template v-if="action.actionType === 'deleteElement'">
                    <!-- Nothing -->
                  </template>
                </v-flex>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
      </div>
      <v-card-actions class="px-3">
        <v-spacer />
        <!-- Delete Action -->
        <v-dialog v-model="deleteDialog" width="500" v-if="isEditMode">
          <v-btn color="error" slot="activator">
            {{ messages.label.REMOVE }}
          </v-btn>
          <v-card>
            <v-card-title class="subheading ttu">
              {{ messages.label.DELETE_ACTION }}
            </v-card-title>
            <v-card-text>
              <p>
                {{ messages.info.DELETE_ACTION_MSG }}
                <b>{{ action.title }}</b> ?
              </p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey lighten-1 white--text" @click="deleteDialog = false">
                {{ messages.label.CANCEL }}
              </v-btn>
              <v-btn color="error" @click="deleteAction">
                {{ messages.label.DELETE }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn color="primary" class="ml-2" :disabled="updatingAction" :loading="updatingAction" v-if="isEditMode"
          @click="updateAction">
          {{ messages.label.DONE }}
        </v-btn>
        <v-btn color="primary" class="ml-2" :disabled="addingAction" :loading="addingAction" @click="addAction" v-else>
          {{ messages.label.ADD }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-slide-x-reverse-transition>
</template>

<script>
import uniqid from "uniqid"
import { mapState, mapActions } from "vuex"
import messages from "@/MetadataRules/messages.json"
import MetadataRulesService from "@/MetadataRules/MetadataRulesService"
import { GET_XPATH_MAPPINGS } from "@/store/constants/action-types"

export default {
  name: "ActionDetails",
  $_veeValidate: {
    validator: "new"
  },
  computed: {
    ...mapState("metadataRules", ["xpathMappings"]),
    ...mapState(["mpxParentAccount"])
  },
  data() {
    return {
      action: {
        id: "",
        title: "",
        actionType: "",
        field: "",
        elementName: "",
        attributeName: "",
        attributeValue: ""
      },
      loadingXpathMappings: false,
      actionTypes: this.retrieveActionTypes(),
      isEditMode: false,
      isVisible: false,
      valid: false,
      deleteDialog: false,
      dictionary: this.getValidationDictionary(),
      addingAction: false,
      updatingAction: false
    }
  },
  watch: {
    action: {
      handler(newValue, oldValue) {
        // Populate data when the action selection changes
        if (newValue.id !== oldValue.id && !this.$lodash.isEmpty(newValue.id)) {
          this.populateActionData(newValue)
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("metadataRules", [GET_XPATH_MAPPINGS]),

    /**
     * hide - Hide side sheet view
     */
    hide() {
      this.isVisible = false
      this.resetActionDetails()
      MetadataRulesService.$emit("event:hideActionDetailsSheet")
    },

    /**
     * show - Show side sheet view
     */
    show(action) {
      this.resetActionData()
      // Wait before updating form
      this.$nextTick(() => {
        this.isVisible = true
        this.$validator.reset()
        if (
          !this.$lodash.isUndefined(action) &&
          !this.$lodash.isEmpty(action)
        ) {
          this.isEditMode = true
          this.action = this.$lodash.cloneDeep(action)
        } else {
          this.isEditMode = false
        }
      })
    },

    /**
     * reseActionData - re initializes data for this view
     */
    resetActionData() {
      this.action = {
        id: "",
        title: "",
        actionType: "",
        field: "",
        elementName: "",
        attributeName: "",
        attributeValue: ""
      }
    },

    /**
     * retrieveActionTypes - List of action types supported
     * @returns {array}
     */
    retrieveActionTypes() {
      let actionTypes = [
        {
          id: 1,
          title: "Insert Attribute",
          value: "insertAttribute"
        },
        {
          id: 2,
          title: "Delete Attribute",
          value: "deleteAttribute"
        },
        {
          id: 3,
          title: "Insert Element",
          value: "insertElement"
        },
        {
          id: 4,
          title: "Update Element",
          value: "updateElement"
        },
        {
          id: 5,
          title: "Delete Element",
          value: "deleteElement"
        }
      ]

      return actionTypes
    },

    /**
     * getValidationDictionary - Validation messages for vee-validate
     * @returns {object}
     */
    getValidationDictionary() {
      return {
        custom: {
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 100 characters"
          },
          actionField: {
            required: () => "Field can't be empty"
          },
          actionType: {
            required: () => "Action Type can't be empty"
          },
          elementName: {
            required: () => "Element Name Type can't be empty"
          },
          attributeName: {
            required: () => "Attribute Name Type can't be empty"
          },
          attributeValue: {
            required: () => "Attribute Value Type can't be empty"
          }
        }
      }
    },

    /**
     * addAction - Add new action
     */
    addAction() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let actionObj = this.constructActionObject()
          MetadataRulesService.$emit("event:addAction", actionObj)
          this.hide()
        }
      })
    },

    /**
     * updateAction - update action details
     */
    updateAction() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let actionObj = this.constructActionObject()
          MetadataRulesService.$emit("event:updateAction", actionObj)
          MetadataRulesService.$emit("event:displaySaveRuleMsg")
          this.hide()
        }
      })
    },

    /**
     * deleteAction - Delete action
     */
    deleteAction() {
      MetadataRulesService.$emit("event:deleteAction", this.action)
      this.deleteDialog = false
      MetadataRulesService.$emit("event:displaySaveRuleMsg")
      this.hide()
    },

    /**
     * constructActionObject - Construct action object
     */
    constructActionObject() {
      const actionType = this.action.actionType
      let actionObject = {
        title: this.action.title,
        field: this.action.field,
        actionType: this.action.actionType
      }

      // Add id if it does't exist
      if (
        this.$lodash.isUndefined(this.action.id) ||
        this.$lodash.isEmpty(this.action.id)
      ) {
        actionObject.id = uniqid()
      } else {
        // Use existing id
        actionObject.id = this.action.id
      }

      switch (actionType) {
        case "insertAttribute":
          actionObject.attributeName = this.action.attributeName
          actionObject.attributeValue = this.action.attributeValue
          break
        case "deleteAttribute":
          actionObject.attributeName = this.action.attributeName
          break
        case "insertElement":
          actionObject.elementName = this.action.elementName
          break
        case "updateElement":
          actionObject.elementName = this.action.elementName
          break
        case "deleteElement":
          // No change
          break
      }

      console.log("Action Object", actionObject)
      return actionObject
    },

    /**
     * populateActionData - Update view with action data
     * @param {object} actionObj
     */
    populateActionData(/* actionObj */) {
      // TODO: Validate if we need to handle any special scenario here
    },

    /**
     * retrieveXPathMappings - Retreive mappings to display field dropdown
     */
    retrieveXPathMappings() {
      // Update store with xpath mappings
      this.loadingXpathMappings = true
      let queryObject = {
        sort: "title",
        account: this.mpxParentAccount.id
      }
      this.GET_XPATH_MAPPINGS(queryObject)
        .catch(() => {
          // TODO: handle error
        })
        .finally(() => {
          this.loadingXpathMappings = false
        })
    },

    /**
     * resetActionDetails - Reset action data and form
     */
    resetActionDetails() {
      this.resetActionData()
      this.$nextTick(() => {
        this.$validator.reset()
      })
    }
  },
  mounted() {
    this.$validator.localize("en", this.dictionary)
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Initial data
     */
    this.retrieveXPathMappings()
    /**
     * Events
     */
    MetadataRulesService.$on("event:showActionDetailsSheet", this.show)
    MetadataRulesService.$on("event:ruleDataRetrieved", this.hide)
  },
  beforeDestroy() {
    MetadataRulesService.$off("event:showActionDetailsSheet", this.show)
    MetadataRulesService.$off("event:ruleDataRetrieved", this.hide)
  }
}
</script>

<style lang="scss">
.action-details {
  min-height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/MetadataRules/Rule/ActionDetails.vue